<template>
  <el-dialog
    :title="pdia.title"
    :visible.sync="pdia.show"
    v-if="pdia.show"
    :close-on-click-modal="false"
  >
    <div class="p-part">
      <h2>{{ listData.chapterName }}</h2>
      <p v-for="x in listData.contentList" :key="x.uuid" v-html="x.content"></p>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn btntype="primary" @click.native="closeFrom()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { bookPreview } from "@/api/book";

export default {
  components: { butn },
  props: ["pdia"],
  data() {
    return {
      listData: [],
    };
  },
  methods: {
    closeFrom() {
      this.$emit("closeDia", "pdia");
    },
  },
  created() {
    bookPreview(this.pdia.uuid)
      .then(({ data, code }) => {
        if (code === 0) {
          this.listData = data;
        }
      })
      .catch(() => {});
  },
};
</script>

<style lang="scss" scoped>
.p-part {
  font-size: 14px;
  line-height: 1.6em;
  h2 {
    text-align: center;
  }
  p {
    line-height: 2em;
    text-indent: 2em;
    padding-bottom: 1.5em;
    overflow: auto;
  }
}
</style>
